import { Component, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'

@Component({
  selector: 'app-continue-case-select-box',
  templateUrl: './continue-case-select-box.component.html',
  styleUrls: ['./continue-case-select-box.component.scss']
})
export class ContinueCaseSelectBoxComponent implements OnInit {
  searchContinueCaseInputControl: FormControl = new FormControl()
  continueCaseId: Number
  editingCaseId: Number
  searchContinueCaseResults: Array<Object> = []
  constructor() {}

  ngOnInit() {}

  async initial() {
    const caseId = this.getCaseId(this.continueCaseId)
    this.searchContinueCaseInputControl.setValue(caseId)
    this.searchContinueCaseResults = this.searchContinueCaseResults.filter(
      x => x['caseId'] !== this.editingCaseId
    )
  }

  getCaseId(id): String {
    const foundCase = this.searchContinueCaseResults.find(x => x['id'] === id)
    return foundCase ? foundCase['caseId'] : null
  }

  getContinueCaseId(): Number {
    const idOfContinueCase = this.searchContinueCaseResults.find(
      x => x['caseId'] === this.searchContinueCaseInputControl.value
    )
    return idOfContinueCase !== undefined ? idOfContinueCase['id'] : null
  }

  disableFormControlIfNotPermitted() {
    this.searchContinueCaseInputControl.disable()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/continue-case-select-box/continue-case-select-box.component.ts